// bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import "./../bindings/bao-toolbar2";
class ChildTabViewModel {
    constructor(tabPage, parent) {
        var self = this;
        if (parent != null && parent.TabPage != null) {
            tabPage.DirtyFlag.subscribe(function (value) {
                if (value == true) {
                    parent.TabPage.DirtyFlag(true);
                }
            });
        }
    }

    Refresh() {
        var def = $.Deferred();
        def.resolve();
        return def.promise();
    }

    Save() {
        var def = $.Deferred();
        def.resolve();
        return def.promise();
    }

    CompleteCheck() {
        return true;
    }
}
export default ChildTabViewModel;